import { Mark } from "./Mark";
import { useConfig } from "../hooks/useConfig";
import { Link } from "../router/router";
import { addressUrl } from "../wallets/chain";
import { shortAddress } from "../lib/format";
import { charityLabel, pledgeText } from "../lib/charity";
import { PAIR_FALLBACK } from "../lib/facts";
import { pledgeCeiling } from "../lib/fees";

export function Footer() {
  const { config } = useConfig();
  const token = config?.token.address ?? null;
  const pair = config?.pair.symbol ?? PAIR_FALLBACK;

  return (
    <footer className="footer">
      <div className="shell footer__grid">
        <div className="stack stack-3">
          <div className="header__mark" aria-hidden="true">
            <Mark />
          TISM
          </div>
          <p className="small" style={{ maxWidth: "40ch" }}>
            A memecoin for autism acceptance on Robinhood Chain, paired with {pair}.{" "}
            {pledgeText(config)} is donated to {charityLabel(config)} every quarter, for as long as the token trades. That is {pledgeCeiling(config)}.
          </p>
          {token ? (
            <p className="tiny">
              Token{" "}
              <a
                href={addressUrl(config?.explorerUrl ?? "", token)}
                target="_blank"
                rel="noreferrer noopener"
              >
                {shortAddress(token, 10, 8)}
              </a>
            </p>
          ) : (
            <p className="tiny">Token address is published here once the launch is live.</p>
          )}
        </div>
        <nav aria-label="Footer">
          <ul className="footer__links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/airdrop">Airdrop</Link>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
            <li>
              <Link to="/terms">Terms</Link>
            </li>
            <li>
              <Link to="/#transparency">Transparency</Link>
            </li>
            {config?.ponsUrl ? (
              <li>
                <a href={config.ponsUrl} target="_blank" rel="noreferrer noopener">
                  Pons listing
                </a>
              </li>
            ) : null}
          </ul>
        </nav>
      </div>
    </footer>
  );
}
